export const dateValidator = /^([0-2][0-9]|(3)[0-1])([/])(((0)[0-9])|((1)[0-2]))([/])([0-9]{4})$/;

export const emailValidator = /^.+@.{2,}\..{2,}$/;

export const nameValidator = /^\p{L}+$/u;

export const fullNameValidator = /^[\p{L}\s]+$/u;

export const phoneValidator = /^[+0-9()-]+$/;
